import { DeleteFileSettingsBase } from 'wizards/models/base/base-models/plan-delete-file-settings-model';
import { EncryptionSettings } from 'wizards/models/base/base-models/plan-encryption-settings-model';
import { SyntheticFull } from 'wizards/models/base/base-models/plan-syntetic-full-model';
import { BasePlan } from 'wizards/models/base/base-plan-models';
import { EncryptionAlgorithm } from 'wizards/models/compression-encription-models';

export class BaseSQLPlanModel extends BasePlan implements EncryptionSettings, DeleteFileSettingsBase, SyntheticFull {
  EncryptionAlgorithm: EncryptionAlgorithm;
  EncryptionKeySize: number;
  IsSyntheticSupported: boolean;
  RetentionDelay: string;
  RetentionDeleteLastVersion: boolean;
  RetentionNumberOfVersions: number;
  RetentionTime: string;
  RetentionUseDefaultSettings: boolean;
  SyntheticFull: boolean;
  UseBackupDate: boolean;
  UseServerSideEncryption: boolean;

  constructor() {
    super();
  }
}
